

export default class DefaultAdapter {
    // constructor(
    //     ctx, _atom, handler,
    //     actionAtom = null,
    //     onAtomChange = null, 
    //     onHandlerChange = null,
    //     build_atom = null,
    //     onBuildAtomChange = null
    // ){
    constructor(config){

        let ctx = config?.ctx
        let _atom = config?.atom
        let handler = config.handler // non optional
        let actionAtom = config?.actionAtom
        let onAtomChange = config?.onAtomChange
        let onHandlerChange = config?.onHandlerChange
        let build_atom = config?.build_atom
        let onBuildAtomChange = config?.onBuildAtomChange
        let onChanged = config?.onChanged

        this.unsubscribes = []

        if(!onAtomChange){
            onAtomChange = (handler, value, ctx=null, _atom=null) => {
                return handler.setValue(value)
            }
        }

        if(!onHandlerChange && _atom){
            // это хук для фильтрации результата выполнения хандлера
            // не использовать вместо onChanged
            onHandlerChange = (handler, ctx=null, _atom=null) => handler.getValue()
        }else if(!onHandlerChange && onChanged){
            onHandlerChange = (handler) => handler.getValue()
        }

        handler.addEventListener('changed', function(){
            let result
            if(onChanged){
                result = onHandlerChange(handler)
                onChanged(result)
                return
            }
            result =  onHandlerChange(handler, ctx, _atom)
            if(actionAtom) {
                actionAtom(ctx, result)
            } else {
                _atom(ctx, result)
            }
        })


        // handler.addEventListener('invalid_rebuild', function(){
        //     console.log('invalid_rebuild', onHandlerChange(handler, ctx, _atom))
        //     _atom(ctx, onHandlerChange(handler, ctx, _atom))
        // })
        if(_atom){
            this.unsubscribes.push(ctx.subscribe(_atom, (value) => {
                onAtomChange(handler, value, ctx, _atom)
            }))
        }

        if(build_atom && !onBuildAtomChange){
            onBuildAtomChange = (handler, value, ctx, _atom) => handler.buildValue(value)
        }

        // console.log(handler, handler.name, build_atom)

        if(build_atom){ 
            this.unsubscribes.push(ctx.subscribe(build_atom, (value) => {

                // const current_value = ctx.get(_atom)

                // console.log('recomputed value', handler.name, value, current_value)
                onBuildAtomChange(handler, value, ctx, _atom)
                // ctx.get(_atom)Value
                // handler.setValue(current_value)
            }))
        }

        this.handler = handler
        this._atom = _atom
        this.ctx = ctx
        this.onAtomChange = onAtomChange
    }
    forceSetCurrentValue(){
        const value = this.ctx.get(this._atom)
        this.onAtomChange(this.handler, value, this.ctx, this._atom)
    }
    unsubscribe(){
        for(const unsubscribe of this.unsubscribes){
            unsubscribe()
        }
    }
}